import {MutationTree} from "vuex";
import DataVariable from '../ts/DataVariableInterface';
import DataVariableGroup from '../ts/DataVariableGroupInterface';
import * as moment from 'moment';

export const mutations: MutationTree<any> = {

    setFilterByGroupModel(state: any, payload: boolean) {
        state.filterByGroupModel = payload;
    },

    setTypeFilterModel(state: any, payload: boolean) {
        state.typeFilterModel = payload;
    },

    setSearchTermModel(state: any, payload: boolean) {
        state.searchTermModel = payload;
    },

    setGroupsLoading(state: any, payload: boolean) {
        state.groupsLoading = payload;
    },

    setGroupsLoaded(state: any, payload: boolean) {
        state.groupsLoaded = payload;
        state.groupsExpire = moment().add(15, 'minutes');
    },

    setGroups(state: any, payload: Array<DataVariableGroup>) {
        state.groups = [];
        state.groups = payload;
    },

    setTableOptions(state: any, payload: boolean) {
        state.tableOptions = payload;
    },

    addGroup(state: any, payload: DataVariable) {
        state.groups.push(payload);
    },

    updateGroup(state: any, payload: DataVariable) {

        let found = state.groups.find((group: DataVariableGroup) => {
            return group.id === payload.id;
        });

        found = Object.assign(found, payload);
    },

    deleteGroup(state: any, payload: number) {
        let index = state.groups.findIndex((group: DataVariableGroup) => group.id === payload);
        if (!index) throw new Error('Could not find data variable group (' + payload + ') when attempting to remove it');
        state.groups.splice(index, 1);
    },

    assignToGroup(state: any, payload: any) {

        payload.dataVariables.forEach((dataVariable: DataVariable) => {
            dataVariable.group_id = payload.groupId;

            let groupFound = state.groups.find((group: DataVariableGroup) => {
                return group.id === payload.groupId;
            });

            if (!groupFound) {
                throw new Error('Group cannot be found!');
            }

            dataVariable.group = groupFound;
        });

    },

    bustGroupCache: (state: any, payload: any) => {
        state.groupsExpire = null;
    },

    setStandardVariables(state: any, payload: boolean) {
        state.standardVariables = payload;
    },

};
